import { Pipe, PipeTransform } from '@angular/core';
import { SortSearchResultsPipe } from './sort-search-results.pipe';

@Pipe({ name: 'splitThenSortSearchResults' })
export class SplitThenSortSearchResultsPipe implements PipeTransform {
    sortPipe: SortSearchResultsPipe = new SortSearchResultsPipe();
    /**
     * Excepts an Array with scheme { 'suggestContentType': SuggestContentType, 'grpInfo': object[] }.
     * @param  objects        Array containing an object with the SuggestContentType and an array of sortable objects
     * @param  sortProperties properties to sort array
     * @return                sorted array
     */
    transform(objects: any[], type: string, sortProperties?: any[]): object[] {
        return this.sortPipe.sort(objects, type);
    }
}
